import { InteractionRequiredAuthError } from "@azure/msal-browser";


export async function acquireGetAccessToken(instance:any, accounts:any) {
    let activeAccount = instance.getActiveAccount();

    if (!activeAccount && accounts.length === 0) {
        console.log('No active account found, triggering login...');
        await instance.loginRedirect();
        return; // Stop function execution after triggering redirect
    }

    if (!activeAccount) {
        // Set the first account as the active account if there's no active account
        activeAccount = accounts[0];
        instance.setActiveAccount(activeAccount);
    }

    const request = {
        scopes: [`${process.env.REACT_APP_API_SCOPE1}`],
        account: activeAccount || accounts[0]
    };
    const requestProfile = {
        scopes: ["User.Read"],
        account: activeAccount || accounts[0]
    };

    try {
        // Try to acquire token silently
        const authResult = await instance.acquireTokenSilent(request);
        const authResultProfile = await instance.acquireTokenSilent(requestProfile);
        localStorage.setItem("accessToken", authResult.accessToken);
        sessionStorage.setItem("accessToken", authResult.accessToken);
        localStorage.setItem("accessProfileToken", authResultProfile.accessToken);

        return {'accessToken':authResult.accessToken,'accessTokenProfile': authResultProfile.accessToken};
    } catch (error: any) {
        console.error("Error acquiring token silently:", error);

        // Handle error if interaction is required
        if (error instanceof InteractionRequiredAuthError) {
            console.log("Interaction required, redirecting...");
            await instance.acquireTokenRedirect(request);
        } else {
            // Handle other errors
            console.error("Token acquisition error:", error);
        }
    }
}


